// Angular
import { Injectable } from '@angular/core';
// Model
import { SubContentModel } from '../model/sub-content.model';
// Other
import { Observable, Observer, Subject } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class SubContentService {
	private subjectOpen: Subject<any> = new Subject();
	private subjectClose: Subject<any> = new Subject();
	private resultEvent: Observer<any>;

	private _isSubContentPanelOpen = false;

	get isSubContentPanelOpen(): boolean {
		return this._isSubContentPanelOpen;
	}

	set isSubContentPanelOpen(value: boolean) {
		this._isSubContentPanelOpen = value;
	}

	/**
   * Broadcast an event to open a Sub Content.
   * @param subContentModel: SubContentModel
   */
	public open(subContentModel: SubContentModel): Observable<any> {
		this.isSubContentPanelOpen = true;
		return new Observable((observer: Observer<any>) => {
			// Keep the reference to the subscription
			this.resultEvent = observer;
			this.subjectOpen.next(subContentModel);
		});
	}

	/**
   * Broadcast an event to close and clear a Sub Content.
   */
	public close(): void {
		this.isSubContentPanelOpen = false;
		this.subjectClose.next({});
	}

	/**
   * On Open subscribe the callback.
   * @param callback: any
   */
	public onOpen(callback: any): any {
		const subscription: any = this.subjectOpen.subscribe(callback);
		return (): void => {
			subscription.remove(subscription);
			subscription.unsubscribe();
		};
	}

	/**
   * On Close subscribe the callback.
   * @param callback: any
   */
	public onClose(callback: any): any {
		const subscription: any = this.subjectClose.subscribe(callback);
		return (): void => {
			subscription.remove(subscription);
			subscription.unsubscribe();
		};
	}

	/**
   * When the event is updated
   */
	public onUpdate(data: any): any {
		this.resultEvent.next(data);
	}

	/**
   * When the event finish on Success
   */
	public onSuccess(data: any): any {
		this.resultEvent.next(data);
		this.resultEvent.complete();
	}

	/**
   * When the event finish by an error
   */
	public onError(data: any): any {
		this.resultEvent.error(data);
		this.resultEvent.complete();
	}
}
